import React, { forwardRef } from 'react';

import { CloseButton, StyledPaper } from './Paper.styles';

export const Paper = forwardRef(
  ({ padding = 2, closeButton, handleClose, ...props }, ref) => {
    return (
      <StyledPaper {...props} ref={ref} padding={padding}>
        {closeButton && <CloseButton onClick={handleClose}>&times;</CloseButton>}
        {props.children}
      </StyledPaper>
    );
  }
);
